// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-search-results-row {
  color: #2196f3;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  font-size: 14px;
  display: flex;
  align-items: center;
}

.header-search-results-row:hover {
  color: #607D8B;
}`, "",{"version":3,"sources":["webpack://./src/components/PageBase/Header/SearchResultRow/SearchResultRow.scss"],"names":[],"mappings":"AAAA;EACC,cAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;AACD;;AAEA;EACC,cAAA;AACD","sourcesContent":[".header-search-results-row {\n\tcolor: #2196f3;\n\tcursor: pointer;\n\tuser-select: none;\n\tfont-size: 14px;\n\tdisplay: flex;\n\talign-items: center;\n}\n\n.header-search-results-row:hover {\n\tcolor: #607D8B;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
